import React from 'react';
import gql from 'graphql-tag';
import { lowerCase } from 'lodash';
import styled from 'styled-components';

import client from '../../../utils/apolloClient';
import { BoxWithHeader } from '../../../components/elements';

const searchMenuModifiersQuery = gql`
  query searchMenuModifiersQuery($input: SearchInput) {
    search_menu_modifiers(input: $input) {
      menu_modifier_listing {
        modifier_groups {
          modifier_group_id
          name
          internal_name
        }
      }
    }
  }
`;

const LoadingSpan = styled.span`
  padding: 1rem;
  color: #00aeef;
  fontsize: 14px;
`;

const Container = styled.div`
  width: 40%;
`;

const Header = styled.div`
  padding: 0.5rem 1rem;
  border: 1px solid ${({ theme }) => theme.lightGreyBeta};
  margin-bottom: 1rem;
  color: black;
  font-weight: 600;
`;

const ModifiersList = ({ placeId, menuItemId, name }) => {
  const [modifiers, setModifiers] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let loadData = true;

    const fetchItems = () => {
      const menu_item_filter = {};

      Object.assign(
        menu_item_filter,
        { place_id: placeId, menu_item_id: menuItemId, name: lowerCase(name) },
        { status: 'ACTIVE' },
      );

      setModifiers([]);
      setLoading(true);

      client.clientPublic
        .query({
          query: searchMenuModifiersQuery,
          variables: {
            input: { filter: { menu_item_filter } },
          },
        })
        .then(({ data }) => {
          if (
            data.search_menu_modifiers &&
            data.search_menu_modifiers.menu_modifier_listing &&
            Array.isArray(data.search_menu_modifiers.menu_modifier_listing) &&
            data.search_menu_modifiers.menu_modifier_listing[0] &&
            data.search_menu_modifiers.menu_modifier_listing[0]
              .modifier_groups &&
            Array.isArray(
              data.search_menu_modifiers.menu_modifier_listing[0]
                .modifier_groups,
            )
          ) {
            if (loadData) {
              setModifiers(
                data.search_menu_modifiers.menu_modifier_listing[0]
                  .modifier_groups,
              );
            }
            setLoading(false);
          }
        })
        .catch(() => {
          setModifiers([]);
          setLoading(false);
        });
    };

    fetchItems();

    return () => {
      loadData = false;
    };
  }, [placeId, menuItemId, name]);

  if (loading) {
    return (
      <>
        <LoadingSpan>Loading...</LoadingSpan>
      </>
    );
  }

  if (modifiers && Array.isArray(modifiers) && modifiers.length !== 0) {
    return (
      <Container>
        <Header>Modifier Groups</Header>
        {modifiers.map(mdf => (
          <BoxWithHeader
            key={mdf.modifier_group_id}
            header={
              <p className="title">
                {mdf.name}{' '}
                <span className="has-text-grey">({mdf.internal_name})</span>
              </p>
            }
          />
        ))}
      </Container>
    );
  }

  return <></>;
};

export default ModifiersList;
